// eslint-disable
import html2pdf from "html2pdf.js";

export const downloadPdf = (elementId) => {
  const element = document.getElementById(elementId);
  const opt = {
    margin: 0.5,
    filename: `${elementId}.pdf`,
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: { scale: 2, logging: true, letterRendering: true },
    jsPDF: { unit: "in", format: "a2", orientation: "portrait" },
  };

  html2pdf().from(element).set(opt).save();
};
